import PropTypes from 'prop-types';
import { memo } from 'react';
// -*- mode: jsx;-*-
import { FundedProjectCard } from './FundedProjectCard.js';


export let FundedProjectList = ({ projects, showClassroomPhoto }) => {
    return (
        <ul className="funded-projects-list">
            {projects
                .filter(p => p.fundingStatus === 'funded')
                .map(p => <FundedProjectCard project={p} key={p.id} showClassroomPhoto={showClassroomPhoto} />)}
        </ul>
    );
};

FundedProjectList.propTypes = {
    projects: PropTypes.arrayOf(PropTypes.object).isRequired,
    showClassroomPhoto: PropTypes.bool,
};

FundedProjectList.defaultProps = {
    showClassroomPhoto: false,
};

FundedProjectList = memo(FundedProjectList);
